import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatCurrency,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_FEES_CONFIGURABLES } from "../../utils/urls";

export const useFeesConfigurables = () => {
  const tableColumns = () => [
    { id: "name", header: "Name" },
    { id: "amount", header: "Amount" },
    { id: "status", header: "Status" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        amount: formatCurrency(item?.amount),
        actions: (
          <FormActions
            actions={createViewEdit(URL_FEES_CONFIGURABLES, item?.id)}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      name: item?.name,
      amount: Number(item?.amount).toLocaleString(),
      description: item?.description,
      status: item?.status,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_FEES_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
